module.exports = __webpack_public_path__ + "img/category-sport-hover.961205d4.png";